var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"landing-categories"},[_c('landing-container',{staticClass:"landing-categories__container"},_vm._l((_vm.cards),function(card,idx){return _c('category-card',{key:idx,attrs:{"img":card.img,"title":card.title}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }